//actions
export const USER_SET_DATA = 'USER/SET_DATA';
export const USER_CLEAR_DATA = 'USER/CLEAR_DATA';
export const TOGGLE_CONNECTEDUSERS_BAR = 'UI/TOGGLE_CONNECTEDBAR';
export const CHANGE_BACKGROUND = 'UI/CHANGE_BACKGROUND';

//action functions
export const setUserData = user =>  {
   return {type: USER_SET_DATA, payload:user};
}

export const clearUserData = () => {
    return {type: USER_CLEAR_DATA};
}

export const toggleConnectedUsersBar = () =>{
    return {type: TOGGLE_CONNECTEDUSERS_BAR}
}

export const changeBackground = imageUrl =>{
    return {type: CHANGE_BACKGROUND, payload: imageUrl}
}